import { determineEnv } from 'util/env';
import tccCredentials from '@tcc/credentials';

export const getGoogleCredentials = (env = determineEnv()) =>
  tccCredentials.forEnv(env).google;
